export enum type {
    GET_EBOOK_LIST = 'GET_EBOOK_LIST',
    GET_EBOOK_LIST_ASYNC = 'GET_EBOOK_LIST_ASYNC',
    GET_EBOOK_DETAILS = 'GET_EBOOK_DETAILS',
    GET_EBOOK_DETAILS_ASYNC = 'GET_EBOOK_DETAILS_ASYNC',
}
